<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs2-20",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 40,
      nextPage: '/questionnaire/section2/21',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'normalBtn',
          mobile: 'normalBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/21-Women’s Health.png'),
        mainTitle: 'Have you ever heard of vaginitis?',
        btn: [
          [
            {
              text: 'Yes',
              operation: 'add product FM-PROBI-101'
            },{
              text: 'No',
            }
          ]
        ],
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
